import OnboardingContainer from '@forwardflow/components/OnboardingContainer'

const NotFound = () => {
   return (
      <OnboardingContainer avatar={false}>
         <div className="flex flex-col items-center justify-center mt-64">
            <h1 className="text-4xl font-bold">404 - Page Not Found</h1>
            <p className="mt-2">
               Looks like this page doesn’t exist or has been moved. Return to
               the{' '}
               <a href="/dashboard" className="text-primary">
                  dashboard.
               </a>
            </p>
         </div>
      </OnboardingContainer>
   )
}

export default NotFound
